import "./AddressTracker.scss";

import { MapContainer, TileLayer, Marker } from "react-leaflet";
import { useEffect, useState } from "react";
import axios from "axios";
export default function AddressTracker() {
  const [info, setInfo] = useState();
  const [ipAddress, setIPAddress] = useState();
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");

  const getData = async () => {
    axios
      .get(
        `https://geo.ipify.org/api/v2/country,city?apiKey=${process.env.REACT_APP_api_key}&ipAddress=${ipAddress}`
      )
      .then((res) => {
        setInfo(res.data);
        setLat(res.data.location.lat);
        setLng(res.data.location.lng);
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  const handleChange = (e) => {
    setIPAddress(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await getData();
  };

  useEffect(() => {
    const getData = async () => {
      await axios
        .get(
          `https://geo.ipify.org/api/v2/country,city?apiKey=${process.env.REACT_APP_api_key}`
        )
        .then((res) => {
          setInfo(res.data);
          setLat(res.data.location.lat);
          setLng(res.data.location.lng);
        })
        .catch((err) => {
          console.log({ err });
        });
    };

    getData();
  }, []);

  return (
    <>
      <article className="search">
        <h1 className="search__heading">IP Address Tracker</h1>
        <div>
          <form className="search__form" onSubmit={handleSubmit}>
            <input
              onChange={handleChange}
              placeholder="Search for any IP address or domain"
            />
            <button type="submit">
              <div className="search__button" />
            </button>
          </form>
        </div>
      </article>

      <article className="infoContainer">
        {info &&
          [info].map((item, i) => {
            return (
              <div key={item.as.asn || i}>
                <div>
                  <span className="info__title">IP Address</span>
                  <p className="info__text">{item.ip}</p>
                </div>
                <div>
                  <span className="info__title">Location</span>
                  <p className="info__text">
                    {item.location.region}, {item.location.country}
                  </p>
                </div>
                <div>
                  <span className="info__title">Timezone</span>
                  <p className="info__text">UTC {item.location.timezone}</p>
                </div>
                <div>
                  <span className="info__title">ISP</span>
                  <p className="info__text">{item.isp}</p>
                </div>
              </div>
            );
          })}
      </article>

      {lat && lng ? (
        <MapContainer
          center={[lat, lng]}
          zoom={13}
          placeholder={<MapContainer />}
          className="container"
          scrollWheelZoom={false}
          style={{ height: "100%" }}
          position={[lat, lng]}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={[lat, lng]}></Marker>
        </MapContainer>
      ) : (
        ""
      )}
    </>
  );
}
